export default [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "x",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "y",
          "type": "uint256"
        }
      ],
      "name": "PRBMath_MulDiv18_Overflow",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "x",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "y",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "denominator",
          "type": "uint256"
        }
      ],
      "name": "PRBMath_MulDiv_Overflow",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PRBMath_SD59x18_Div_InputTooSmall",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "SD59x18",
          "name": "x",
          "type": "int256"
        },
        {
          "internalType": "SD59x18",
          "name": "y",
          "type": "int256"
        }
      ],
      "name": "PRBMath_SD59x18_Div_Overflow",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "SD59x18",
          "name": "x",
          "type": "int256"
        }
      ],
      "name": "PRBMath_SD59x18_Exp2_InputTooBig",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "SD59x18",
          "name": "x",
          "type": "int256"
        }
      ],
      "name": "PRBMath_SD59x18_Exp_InputTooBig",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PRBMath_SD59x18_Mul_InputTooSmall",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "SD59x18",
          "name": "x",
          "type": "int256"
        },
        {
          "internalType": "SD59x18",
          "name": "y",
          "type": "int256"
        }
      ],
      "name": "PRBMath_SD59x18_Mul_Overflow",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "teamOwner",
          "type": "address"
        }
      ],
      "name": "JoinTeam",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "tradeHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isDegen",
          "type": "bool"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "leaderTeam",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "memberTeam",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "epochId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "openPoints",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "closePoints",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "holdingSeconds",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "finalPoints",
          "type": "uint256"
        }
      ],
      "name": "PointsFromPosition",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "epochId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "generalBoostPoints",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "degenBoostPoints",
          "type": "uint256"
        }
      ],
      "name": "PointsFromTeamBoostReward",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "leader",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "member",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isDegen",
          "type": "bool"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "epochId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "rewardPoints",
          "type": "uint256"
        }
      ],
      "name": "PointsFromTeamMemberReward",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "code",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "teamName",
          "type": "string"
        }
      ],
      "name": "TeamCreate",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "epochId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isDegen",
          "type": "bool"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "leaderTeam",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "memberTeam",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "volumeUSD",
          "type": "uint256"
        }
      ],
      "name": "TradingVolume",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "createTeamMinVolumeUSD",
              "type": "uint256"
            },
            {
              "internalType": "uint24",
              "name": "openVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "closeVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenOpenVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenCloseVolumePointsP",
              "type": "uint24"
            }
          ],
          "indexed": false,
          "internalType": "struct GenesisAirdrop.Params",
          "name": "newParams",
          "type": "tuple"
        }
      ],
      "name": "UpdateParams",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "tradeHash",
          "type": "bytes32"
        },
        {
          "components": [
            {
              "internalType": "uint128",
              "name": "closePrice",
              "type": "uint128"
            },
            {
              "internalType": "int96",
              "name": "fundingFee",
              "type": "int96"
            },
            {
              "internalType": "uint96",
              "name": "closeFee",
              "type": "uint96"
            },
            {
              "internalType": "int96",
              "name": "pnl",
              "type": "int96"
            },
            {
              "internalType": "uint96",
              "name": "holdingFee",
              "type": "uint96"
            }
          ],
          "internalType": "struct CloseInfo",
          "name": "info",
          "type": "tuple"
        }
      ],
      "name": "afterClose",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "tradeHash",
          "type": "bytes32"
        },
        {
          "components": [
            {
              "internalType": "address",
              "name": "user",
              "type": "address"
            },
            {
              "internalType": "uint32",
              "name": "userOpenTradeIndex",
              "type": "uint32"
            },
            {
              "internalType": "uint40",
              "name": "holdingFeeRate",
              "type": "uint40"
            },
            {
              "internalType": "uint128",
              "name": "entryPrice",
              "type": "uint128"
            },
            {
              "internalType": "uint128",
              "name": "qty",
              "type": "uint128"
            },
            {
              "internalType": "address",
              "name": "pairBase",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "tokenPay",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "lvToken",
              "type": "address"
            },
            {
              "internalType": "uint96",
              "name": "lvMargin",
              "type": "uint96"
            },
            {
              "internalType": "uint128",
              "name": "stopLoss",
              "type": "uint128"
            },
            {
              "internalType": "uint128",
              "name": "takeProfit",
              "type": "uint128"
            },
            {
              "internalType": "uint24",
              "name": "broker",
              "type": "uint24"
            },
            {
              "internalType": "bool",
              "name": "isLong",
              "type": "bool"
            },
            {
              "internalType": "uint32",
              "name": "timestamp",
              "type": "uint32"
            },
            {
              "internalType": "uint96",
              "name": "lvOpenFee",
              "type": "uint96"
            },
            {
              "internalType": "uint96",
              "name": "lvExecutionFee",
              "type": "uint96"
            },
            {
              "internalType": "int256",
              "name": "longAccFundingFeePerShare",
              "type": "int256"
            },
            {
              "internalType": "uint256",
              "name": "openBlock",
              "type": "uint256"
            }
          ],
          "internalType": "struct ITrading.OpenTrade",
          "name": "ot",
          "type": "tuple"
        }
      ],
      "name": "afterMarketExecuted",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "tradeHash",
          "type": "bytes32"
        },
        {
          "internalType": "enum ITradingChecker.Refund",
          "name": "refund",
          "type": "uint8"
        }
      ],
      "name": "afterMarketRefund",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32[]",
          "name": "tradeHashes",
          "type": "bytes32[]"
        },
        {
          "internalType": "uint256[]",
          "name": "marketPrices",
          "type": "uint256[]"
        }
      ],
      "name": "batchCalcPositionBasicPoints",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "openPoints",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closePoints",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "holdingSeconds",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "holdingBoostP",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "teamBoostP",
              "type": "uint256"
            }
          ],
          "internalType": "struct GenesisAirdrop.PositionSettledUIData[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "config",
      "outputs": [
        {
          "internalType": "contract IEarnConfig",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "teamName",
          "type": "string"
        }
      ],
      "name": "createTeam",
      "outputs": [
        {
          "internalType": "string",
          "name": "code",
          "type": "string"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "teamName",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "code",
          "type": "string"
        }
      ],
      "name": "createTeamV2",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "deployedUTCDay",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        }
      ],
      "name": "getUIData",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "currentEpoch",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "userGeneralPoints",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "userDegenPoints",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "userCumulativeVolumeUSD",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "teamBoostGeneralClaimable",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "teamBoostDegenClaimable",
                  "type": "uint256"
                }
              ],
              "internalType": "struct GenesisAirdrop.UserUIData",
              "name": "userData",
              "type": "tuple"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "totalGeneralPoints",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "totalDegenPoints",
                  "type": "uint256"
                }
              ],
              "internalType": "struct GenesisAirdrop.PointsUIData",
              "name": "pointsData",
              "type": "tuple"
            }
          ],
          "internalType": "struct GenesisAirdrop.UIData",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "contract IEarnConfig",
          "name": "_config",
          "type": "address"
        },
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "createTeamMinVolumeUSD",
              "type": "uint256"
            },
            {
              "internalType": "uint24",
              "name": "openVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "closeVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenOpenVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenCloseVolumePointsP",
              "type": "uint24"
            }
          ],
          "internalType": "struct GenesisAirdrop.Params",
          "name": "initialParams",
          "type": "tuple"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "code",
          "type": "string"
        }
      ],
      "name": "joinTeam",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "createTeamMinVolumeUSD",
              "type": "uint256"
            },
            {
              "internalType": "uint24",
              "name": "openVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "closeVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenOpenVolumePointsP",
              "type": "uint24"
            },
            {
              "internalType": "uint24",
              "name": "degenCloseVolumePointsP",
              "type": "uint24"
            }
          ],
          "internalType": "struct GenesisAirdrop.Params",
          "name": "newParams",
          "type": "tuple"
        }
      ],
      "name": "updateParams",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    }
  ] as const;
